import { render } from "./batchPushModal.vue?vue&type=template&id=0bf09bf2&scoped=true"
import script from "./batchPushModal.vue?vue&type=script&lang=js"
export * from "./batchPushModal.vue?vue&type=script&lang=js"

import "./batchPushModal.vue?vue&type=style&index=0&id=0bf09bf2&lang=less&scoped=true"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf09bf2"]])

export default __exports__